import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { SERVER_URL, BUILD_PLATFORM, PLATFORM_PWA, PLATFORM_ANDROID, PLATFORM_IOS } from '../constants';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ListItemIcon from "@mui/material/ListItemIcon";
// import { downloadCsv, downloadCsvAndroid } from '../helpers/Helpers';
import { downloadCsv } from '../helpers/Helpers';
import QuickModal from './QuickModal';
import { formatDate } from '../helpers/Helpers';
import dayjs from 'dayjs';
import ScheduleDelete from './ScheduleDelete';
import VerticalHamburgerMenu from './VerticalHamburgerMenu';
import { formatTime } from '../helpers/Helpers';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Box from '@mui/material/Box';
import AddTimeSlot from './AddTimeSlot';
import GenerateFixedSchedLink from './GenerateFixedSchedLink';
import TimeSlotListNotesEditor from './TimeSlotListNotesEditor';
import { appointmentStatusToString } from '../helpers/Helpers';
import EditTodaysSchedule from './EditTodaysSchedule';
import OfficeTodaysFixedScheduleAddName from './OfficeTodaysFixedScheduleAddName';
import OfficeTodaysFixedScheduleStatusChange from './OfficeTodaysFixedScheduleStatusChange';
import OfficeTodaysFixedScheduleTimeChange from './OfficeTodaysFixedScheduleTimeChange';
import { appointmentStatusAvatarStyle, appointmentStatusToIcon } from '../helpers/Helpers';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));
  
  
function SchedulesCalendarTimeSlotList (props) {

    useEffect(() => {
        fetchTimeSlotList();
        fetchScheduleDetails(props.scheduleId);
    }, []);

    const today = dayjs();

    const [open, setOpen] = React.useState(true);

    const [message, setMessage] = useState("fetching data...");

    const [openAddCustomerModal, setOpenCustomerModal] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        fetchTimeSlotList()
    };

    const handleClose = (event, reason) => {
        if (quickModalMessage) {
            setQuickModalOpen(true);
            return;
        }
        if (reason == 'backdropClick') {
            return;
        }
        setOpen(false);
        props.setSelectedSchedule(null);
    };   

    const [scheduleData, setScheduleData] = useState();

    const [timeSlots, setTimeSlots] = useState([]);

    const [csvData, setCsvData] = useState([]);
    
    const convertDataForCsv = (jsonData) => {
        // console.log("jsonData", jsonData);
        var array = [];
        var header = {time: 'Time', name: 'Name', status: 'Status'};
        array.push(header);
        for (var item of jsonData) 
        {
            var object = {};
            object.time = formatTime(item.time);
            object.name = item.name;
            object.status = appointmentStatusToString(item.appointment_status);
            array.push(object);
        }
        setCsvData(array);
    }

    const handleDownloadCsv = (params) => {
        var csvFilename = props.officeName + " Timeslots List " + props.rawDate;
        if (BUILD_PLATFORM === PLATFORM_PWA)
        {
            downloadCsv({data: params.data, fileName: csvFilename});
        }
        // if (BUILD_PLATFORM === PLATFORM_ANDROID)
        // {
        //     downloadCsvAndroid({data: csvData, fileName: csvFilename});
        //     setQuickModalMessage( "CSV file downloaded to your Documents folder: [" + csvFilename + ".csv]");
        //     setQuickModalOpen(true);
        // }
    }

    const handleDeleteSchedule = () => {
        setQuickModalMessage("");
        setDeleteModalOpen(true);
    }

    const handleDeleteTimeSlot = (params) => {
        deleteTimeSlot(params.timeSlotId);
    }

    const [selectedTimeSlot, setSelectedTimeSlot] = useState({});

    const handleNotes = (params) => {
        setSelectedTimeSlot(params);
        setOpenNotesEditor(true);
    }
    
     const [insertCustomerData, setInsertCustomerData] = useState({});

    const handleInsertCustomer = (params) => {
        // console.log("handleAddCustomer ", params);
        setInsertCustomerData({
            time_slot_id: params.timeSlotId,
            office_id: params.officeId,
            time: params.time,
        });
        setOpenCustomerModal(true);
    }

    const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
    const [statusChangeData, setStatusChangeData] = useState({});

    const handleStatusChange = (params) => {
        // console.log("handleStatusChange", params);
        setStatusChangeData({
            office_id: params.officeId,
            id: params.appointmentId,
            name: params.customerName,
            status: params.status
        });
        setOpenStatusChangeModal(true);
    }

    const [timeChangeData, setTimeChangeData] = useState({});
    const [openTimeChangeModal, setOpenTimeChangeModal] = useState(false);

    const handleTimeChange = (params) => {
        // console.log("handleTimeChange", params);
        setTimeChangeData({
            office_id: params.officeId,
            id: params.appointmentId,
            name: params.customerName,
            status: params.status,
            time: params.time,
            time_slot_id: params.timeSlotId,
        });
        setOpenTimeChangeModal(true);
    }

    const [verticalMenuOptions, setVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Export List",
            callback: handleDownloadCsv
        },
        ...(!dayjs(props.rawDate).isBefore(today, 'day')
            ? 
            [
                {
                    id: 2,
                    name: "Delete Schedule",
                    callback: handleDeleteSchedule
                },
            ]
        : []),
    ]);

    const [timeSlotVerticalMenuOptions, setTimeSlotVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Notes",
            callback: handleNotes,
        },
        {
            id: 2,
            name: "Change Status",
            callback: handleStatusChange,
        },
        {
            id: 3,
            name: "Change Time",
            callback: handleTimeChange,
            confirmMessage: "Are you sure you want to change the appointment time? This may cause confusion or dissatisfaction on the part of the customer."
        },
        {
            id: 4,
            name: "Delete Timeslot",
            callback: handleDeleteTimeSlot,
            confirmMessage: 'Are you sure you want to delete this timeslot?'
        },
    ]);

    const [reducedTimeSlotVerticalMenuOptions, setReducedTimeSlotVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Insert Client/Customer",
            callback: handleInsertCustomer,
        },
        {
            id: 2,
            name: "Delete Timeslot",
            callback: handleDeleteTimeSlot,
            confirmMessage: 'Are you sure you want to delete this timeslot?'
        }
    ]);

    const [deleModalOpen, setDeleteModalOpen] = useState(false);

    const [quickModalOpen, setQuickModalOpen] = useState(false);

    const [quickModalMessage, setQuickModalMessage] = useState("");

    const [latestTime, setLatestTime] = React.useState("");

    const [openNotesEditor, setOpenNotesEditor] = useState(false);

    const fetchTimeSlotList = () => {
        // console.log("fetchTimeSlotList() scheduleId", props.scheduleId);
        setProcessing(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/list-timeslots/' + props.scheduleId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            setProcessing(false);
            // console.log("data.data", data.data);
            if (data.data.length > 0) {
                const mostRecentTime = data.data.reduce((latest, current) => {
                    return current.time > latest.time ? current : latest;
                }).time;
                setTimeSlots(data.data);
                setLatestTime(mostRecentTime);
                convertDataForCsv(data.data);
                setQuickModalMessage("");
            } else {
                if (data.data.length < 1) {
                    setTimeSlots([]);
                    setMessage("No timeslots found");
                    setQuickModalMessage(<><p>Please enter timeslots for the schedule.</p> <p>Click the <MoreTimeIcon fontSize='large' sx={{ verticalAlign: 'middle' }}/> button.</p></>);
                }
            }
        })
        .catch((err) => {
            setProcessing(false);
            console.error(err);
        });
    }

    const [processing, setProcessing] = useState(false);

    const deleteTimeSlot = (id) => {
            setProcessing(true);
            const token = sessionStorage.getItem("token");
            fetch(SERVER_URL + 'api/mod/delete-timeslot',
            {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                },
                body: JSON.stringify({
                    "id": id
                })
            })
            .then(response => response.json())
            .then(data => {
                setProcessing(false);
                if (data.status == 1) {
                    fetchTimeSlotList();
                } else {
                    
                }
            })
            .catch((err) => {
                setProcessing(false);
                console.error(err);
            });
        }

    const fetchScheduleDetails = (id) => {
        // console.log("fetchScheduleDetails ", id);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/detail-schedule/' + id, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data.data);
            setScheduleData(data.data);
        })
        .catch(err => console.error(err));
    }

    return(
        <React.Fragment>
            <QuickModal 
                quickModalOpen={quickModalOpen}
                quickModalMessage={quickModalMessage}
                setQuickModalOpen={setQuickModalOpen} 
            />
            
            <BootstrapDialog
            sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "500px",  // Set your width here
                  },
                },
            }}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}
                >
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                    Fixed Schedule
                    </Typography>
                    {scheduleData ? 
                    <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                    {props.date} {formatTime(scheduleData.start_time)} - {formatTime(scheduleData.end_time)}
                    </Typography> 
                    : null}
                    <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                    {props.officeName}<br />
                    </Typography>
                    {  !dayjs(props.rawDate).isBefore(today, 'day') ?
                    <Stack alignItems="center" justifyContent="center" direction="row" spacing={1}>
                        <GenerateFixedSchedLink setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices} officeId={props.officeId} officeName={props.officeName}/>
                        <AddTimeSlot 
                            startTime={props.startTime} 
                            averageServeMinutes={props.averageServeMinutes} 
                            latestTime={latestTime} 
                            fetchTimeSlotList={fetchTimeSlotList} 
                            scheduleId={props.schedule.id} 
                            fetchSchedulesList={props.fetchSchedulesList}
                            date={formatDate(props.schedule.date)} 
                            rawDate={props.rawDate} 
                        />
                        <EditTodaysSchedule 
                            hideMaxClients={true}
                            maxClients={props.schedule.max_clients}
                            averageServeMinutes={props.averageServeMinutes} 
                            rawDate={props.rawDate} 
                            officeName={props.officeName} 
                            scheduleId={props.schedule.id} 
                            fetchOffices={props.fetchOffices} 
                            date={formatDate(props.schedule.date)} 
                            startTime={props.schedule.start_time} 
                            endTime={props.schedule.end_time} 
                            fetchSchedulesList={props.fetchSchedulesList} 
                            fetchScheduleDetails={fetchScheduleDetails}
                        />
                    </Stack>
                    : null }
                </Stack>
            </DialogTitle>
            
            <DialogContent sx={{ m: 0, p: 0 }} dividers>
                
                <List>
                    {timeSlots.map(timeSlot => (
                        <ListItem key={timeSlot.id} alignItems="center">
                            <ListItemAvatar>
                                {timeSlot.appointment_status ? 
                            <Avatar sx={appointmentStatusAvatarStyle(timeSlot.appointment_status)}>
                                {appointmentStatusToIcon(timeSlot.appointment_status)}
                            </Avatar>
                            :
                            <Avatar>
                                <AccessAlarmIcon />
                            </Avatar>
                            }
                        </ListItemAvatar>
                            <ListItemText
                                sx={{ textAlign: 'center' }}
                                primary={formatTime(timeSlot.time)}
                                secondary={
                                    <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'pre-line' }}>
                                     {timeSlot.user_id && timeSlot.name ? <strong>{timeSlot.name}</strong> : null}
                                     {timeSlot.user_id ? <br /> : null}
                                     {timeSlot.user_id ? appointmentStatusToString(timeSlot.appointment_status) : null}
                                    </Typography>
                                }
                            />
                            <ListItemIcon>
                                <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                                    <VerticalHamburgerMenu 
                                        params={{
                                            timeSlotId: timeSlot.id, 
                                            appointmentId: timeSlot.appointment_id,
                                            customerId: timeSlot.user_id,
                                            status: timeSlot.appointment_status,
                                            customerName: timeSlot.name,
                                            officeId: props.officeId,
                                            time: timeSlot.time
                                        }} 
                                        options={ timeSlot.appointment_id ? timeSlotVerticalMenuOptions : reducedTimeSlotVerticalMenuOptions} 
                                    />
                                </Box>
                                {/* <CustomerListOptions minutes={customerAppointment.minutes} status={customerAppointment.status} date={props.rawDate} officeId={props.officeId} appointmentId={customerAppointment.id} customerId={customerAppointment.user_id} customerName={customerAppointment.name} /> */}
                            </ListItemIcon>
                        </ListItem>
                    ))} 
                    {timeSlots.length < 1 ? <Typography  sx={{ ml: 2, flex: 1 }} variant="body2" component="div">{ message }</Typography> : null}
                </List>
                {selectedTimeSlot.appointmentId ? 
                <TimeSlotListNotesEditor 
                    showIcon={false}
                    openNotesEditor={openNotesEditor}
                    setOpenNotesEditor={setOpenNotesEditor}
                    status={selectedTimeSlot.status} 
                    date={props.rawDate} officeId={props.officeId} 
                    appointmentId={selectedTimeSlot.appointmentId} 
                    customerId={selectedTimeSlot.customerId} 
                    customerName={selectedTimeSlot.customerName} 
                />
                :null }
                {insertCustomerData.time_slot_id ? 
                <OfficeTodaysFixedScheduleAddName 
                    openAddCustomerModal={openAddCustomerModal}
                    setOpenCustomerModal={setOpenCustomerModal}
                    officeId={props.officeId} 
                    timeSlotId={insertCustomerData.time_slot_id} 
                    time={insertCustomerData.time}
                    fetchTimeSlotList={fetchTimeSlotList}
                />
                :null }
                {statusChangeData.id ? 
                <OfficeTodaysFixedScheduleStatusChange 
                    customerAppointment={statusChangeData} 
                    openStatusChangeModal={openStatusChangeModal} 
                    setOpenStatusChangeModal={setOpenStatusChangeModal} 
                    fetchTimeSlotList={fetchTimeSlotList}
                    statusOptions={[
                        { value: 1, label: "Confirmed" },
                        { value: 2, label: "Cancelled" },
                    ]}
                /> : null}
                {timeChangeData.id ? 
                <OfficeTodaysFixedScheduleTimeChange 
                    customerAppointment={timeChangeData} 
                    openTimeChangeModal={openTimeChangeModal} 
                    setOpenTimeChangeModal={setOpenTimeChangeModal} 
                    fetchTimeSlotList={fetchTimeSlotList}
                /> : null}
                </DialogContent>
                <DialogActions>
                    <VerticalHamburgerMenu 
                        options={verticalMenuOptions} 
                        params={{
                            data: csvData
                        }}
                    />
                    {  !dayjs(props.rawDate).isBefore(today, 'day') ?
                        <ScheduleDelete setDeleteModalOpen={setDeleteModalOpen} open={deleModalOpen} hideButton={true} handleClose={handleClose} rawDate={props.rawDate} fetchSchedulesList={props.fetchSchedulesList} scheduleId={props.schedule.id} officeName={props.officeName} scheduleDate={formatDate(props.schedule.date)} edge="end" aria-label="delete" />
                    : null }
                    {/* {!dayjs(props.rawDate).isBefore(today, 'day') ? <EditCustomerName hideButton={true} setAddCustomerModalOpen={setAddCustomerModalOpen} open={addCustomerModalOpen} officeId={props.officeId} rawDate={props.rawDate} fetchCustomerAppointments={fetchCustomerAppointments} fetchOffices={props.fetchOffices} /> : null } */}
                    <div style={{flex: '1 0 0'}} />
                    <Button disabled={processing} autoFocus onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default SchedulesCalendarTimeSlotList;